import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { DevModal } from "@components/Helpers";

function ImagePreviewModal({ url }) {
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const [width, setWidth] = useState();
    const [height, setHeight] = useState();

    const handleClose = () => setShow(false);

    const handleShow = () => setShow(true);

    const getMeta = async (imgurl) => {
        const img = new Image();
        img.src = imgurl;
        await img.decode();
        return img;
    };

    useEffect(() => {
        if (url) {
            getMeta(url).then((data) => {
                setHeight(data.naturalHeight);
                setWidth(data.naturalWidth);
            });
        }
    }, [url]);

    return (
        <>
            <img
                onClick={handleShow}
                className="img-thumbnail dev-listing-img"
                src={url}
                alt="image"
                style={{ cursor: "pointer" }}
            />

            <DevModal
                show={show}
                onHide={handleClose}
                body={
                    <>
                        <div className="d-flex justify-content-center">
                            <img className="img-thumbnail" src={url} alt="image" />
                        </div>
                        <div className="mt-3">
                            <span>{t("Ссылка")}:</span>{" "}
                            <a href={url} target="_blank" style={{ wordWrap: "break-word" }}>
                                {url}
                            </a>
                        </div>
                        <div className="mt-2">
                            <span>{t("Размер")}:</span>{" "}
                            <span>
                                {width}x{height}
                            </span>
                        </div>
                    </>
                }
                footer={
                    <Button variant="light" onClick={handleClose}>
                        {t("Закрыть")}
                    </Button>
                }
            />
        </>
    );
}

export default ImagePreviewModal;
